import React, { useContext, useEffect, useState } from 'react'
import DocumentsContext from 'app/react/components/documents/DocumentsContext'
import Document from 'app/react/components/documents/Document'
import classNames from 'classnames'

import _ from 'lodash'

export default function Table () {

  const { documents, setDocuments, page, postsPerPage, texts } = useContext(DocumentsContext)
  const [sortDirections, setSortDirections] = useState({
    filename: false,
    date: false,
    filesize: false
  })

  const [documentChunk, setDocumentChunk] = useState(documents)

  useEffect(() => {
    const realPage = page - 1
    const start = realPage === 0 ? 0 : realPage * postsPerPage
    const end = page * postsPerPage
    setDocumentChunk(documents.slice(start, end))
  }, [documents, page])

  const handleSortDocuments = (type) => {
    sortDirections[type] = !sortDirections[type]
    setSortDirections(sortDirections)

    const sortDirection = sortDirections[type] ? 'asc' : 'desc'
    const sorted = _.orderBy(documents, [type], [sortDirection])

    setDocuments(sorted)
  }

  return (
    <div className="dm-documents-table">
      {documentChunk.length > 0 ? (
        <>
          <div className="dm-documents-table__header">
            <div className={classNames('dm-documents-table__head column-name', {
              'dm-documents-table__head--asc': sortDirections['filename']
            })} onClick={() => handleSortDocuments('filename')}>{texts.fileName}</div>
            <div className={classNames('dm-documents-table__head column-date', {
              'dm-documents-table__head--asc': sortDirections['date']
            })} onClick={() => handleSortDocuments('date')}>{texts.fileDate}</div>
            <div className={classNames('dm-documents-table__head column-size', {
              'dm-documents-table__head--asc': sortDirections['filesize']
            })} onClick={() => handleSortDocuments('filesize')}>{texts.fileSize}</div>
            <div className="dm-documents-table__head column-download"/>
          </div>
          <div className="dm-documents-table__rows">
            {documentChunk.map((doc) => <Document key={doc.id} {...doc} />)}
          </div>
        </>
      ): (<div className="dm-documents-table__error dm-wysiwyg">{texts.errorMessage}</div>)}
    </div>
  )
}
